// Step 11 commit 1 / PP1 bug #2 fix (Jun 17): standalone exit-flow
// handler extracted from ImpersonationBanner so the state machine
// is unit-testable. The banner only wires React setters; all the
// fetch + navigation + error-shaping logic lives here.
//
// The original handler used router.refresh() + router.push() which
// raced each other - the cached layout under /admin/clients kept
// rendering the banner gate with stale state because cookie jar
// updates from Set-Cookie hadn't propagated through the App Router
// cache by the time router.push consumed it. window.location.href
// is a full browser navigation that re-reads the cookie jar +
// re-renders every layout from scratch.

export const EXIT_IMPERSONATION_PATH = "/api/admin/impersonate/exit";
export const EXIT_REDIRECT_PATH = "/admin/clients";

export type FetchLike = (
  input: RequestInfo | URL,
  init?: RequestInit,
) => Promise<Response>;

export type RunExitImpersonationDeps = {
  fetchImpl: FetchLike;
  navigate: (href: string) => void;
  onError: (message: string) => void;
};

export async function runExitImpersonation({
  fetchImpl,
  navigate,
  onError,
}: RunExitImpersonationDeps): Promise<void> {
  let r: Response;
  try {
    r = await fetchImpl(EXIT_IMPERSONATION_PATH, {
      method: "POST",
      credentials: "include",
    });
  } catch (err) {
    if (typeof console !== "undefined" && console.error) {
      console.error("impersonate exit error", err);
    }
    onError("Network error");
    return;
  }
  if (!r.ok) {
    let body = "";
    try {
      body = await r.text();
    } catch {
      // ignore body read failure; status is enough
    }
    if (typeof console !== "undefined" && console.error) {
      console.error("impersonate exit failed", r.status, body);
    }
    onError(`Exit failed (${r.status})`);
    return;
  }
  // Hard nav so the browser re-reads cookies (the server cleared the
  // impersonation cookie with max-age=0) + every server component
  // re-renders without stale router-cache state.
  navigate(EXIT_REDIRECT_PATH);
}
